import React, { useState, createContext, useRef, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { useScroll, useMotionValueEvent } from "framer-motion";

const ThemeContext = createContext({
  layout: { current: null },
  width: 0,
  height: 0,
  isFirstTime: false,
  setIsFirstTime: () => {},
  isOpen: false,
  setIsOpen: () => {},
  isProjectsOpen: false,
  setIsProjectsOpen: () => {},
  setIsOverHalf: () => {},
  isOverHalf: false,
  isSingleProjectPage: false,
  setIsSingleProjectPage: () => {},
  isAuxPage: false,
  setIsAuxPage: () => {},
  isAuxMenuVisible: true,
  setIsAuxMenuVisible: () => {},
  whichHovered: null,
  setWhichHovered: () => {},
  auxMenuComponents: null,
  setAuxMenuComponents: () => {},
  header: { current: null },
  headerHeight: 0,
  setHeaderHeight: () => {},
  pageMarginTop: 108,
  setPageMarginTop: () => {},
  mainRef: { current: null },
  isScrolledBottom: false,
  isMobileMenuOpen: false,
  setIsMobileMenuOpen: () => {},
});

const ThemeProvider = ({ children }) => {
  const layout = useRef(null);
  const header = useRef(null);
  const { width, height } = useWindowSize();

  const [isOverHalf, setIsOverHalf] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isProjectsOpen, setIsProjectsOpen] = useState(false);
  const [isSingleProjectPage, setIsSingleProjectPage] = useState(false);
  const [isAuxPage, setIsAuxPage] = useState(false);
  const [isAuxMenuVisible, setIsAuxMenuVisible] = useState(true);
  const [whichHovered, setWhichHovered] = useState("default");

  const [auxMenuComponents, setAuxMenuComponents] = useState();

  const [headerHeight, setHeaderHeight] = useState(0);
  const [pageMarginTop, setPageMarginTop] = useState(108);
  useEffect(() => {
    if (width > 768) {
      setPageMarginTop(108);
    } else {
      setPageMarginTop(75);
    }
  }, [width]);

  useEffect(() => {
    if (!isOpen) {
      setIsProjectsOpen(false);
    }
  }, [isOpen]);

  const [isFirstTime, setIsFirstTime] = useState(false);
  useEffect(() => {
    setIsFirstTime(sessionStorage.getItem("isFirstTime") === null);
  }, []);
  useEffect(() => {
    if (isFirstTime) {
      sessionStorage.setItem("isFirstTime", "false");
    }
  }, [isFirstTime]);

  const mainRef = useRef(null);
  const [isScrolledBottom, setIsScrolledBottom] = useState(false);
  const { scrollYProgress } = useScroll();
  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    if (latest === 1) {
      setIsScrolledBottom(true);
    } else {
      setIsScrolledBottom(false);
    }
  });

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <ThemeContext.Provider
      value={{
        layout,
        width,
        height,
        isFirstTime,
        setIsFirstTime,
        isOpen,
        setIsOpen,
        isProjectsOpen,
        setIsProjectsOpen,
        setIsOverHalf,
        isOverHalf,
        isSingleProjectPage,
        setIsSingleProjectPage,
        isAuxPage,
        setIsAuxPage,
        isAuxMenuVisible,
        setIsAuxMenuVisible,
        whichHovered,
        setWhichHovered,
        auxMenuComponents,
        setAuxMenuComponents,
        header,
        headerHeight,
        setHeaderHeight,
        pageMarginTop,
        setPageMarginTop,
        mainRef,
        isScrolledBottom,
        isMobileMenuOpen,
        setIsMobileMenuOpen,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };
